import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Grid,
  Paper
} from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { changePassword } from 'store/actions';
import { useDispatch } from 'react-redux';

// Validation schema
const validationSchema = Yup.object({
  currentPassword: Yup.string().required('Current password is required'),
  newPassword: Yup.string().required('New password is required'),
  confirm: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Passwords do not match')
    .required('Confirm password is required'),
});

const ChangePassword = () => {
  const dispatch = useDispatch();

  return (
    <Box sx={{ p: 3 }}>
      <Paper elevation={1} sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Change Password
        </Typography>

        <Formik
          initialValues={{ currentPassword: '', newPassword: '', confirm: '' }}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm}) => {
            dispatch(
              changePassword(values, (result) => {
                resetForm();
              })
            );}}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleReset,
            status,
          }) => (
            <Form>
              {status && status.message && (
                <Alert severity={status.success ? 'success' : 'error'} sx={{ mb: 2 }}>
                  {status.message}
                </Alert>
              )}

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Current Password"
                    type="password"
                    name="currentPassword"
                    value={values.currentPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.currentPassword && Boolean(errors.currentPassword)}
                    helperText={touched.currentPassword && errors.currentPassword}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="New Password"
                    type="password"
                    name="newPassword"
                    value={values.newPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.newPassword && Boolean(errors.newPassword)}
                    helperText={touched.newPassword && errors.newPassword}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Confirm Password"
                    type="password"
                    name="confirm"
                    value={values.confirm}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.confirm && Boolean(errors.confirm)}
                    helperText={touched.confirm && errors.confirm}
                  />
                </Grid>
              </Grid>

              {/* Buttons */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 2 }}>
                <Button variant="contained"  className="create-btn" type="submit">
                  Change Password
                </Button>
                <Button color="error" onClick={handleReset}>
                  Clear
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Paper>
    </Box>
  );
};

export default ChangePassword;
